module.exports = __webpack_public_path__ + "static/media/Loop_Stills_Smaller.bbc17cbf.mp4";